/**
 * BritBag product card behaviour — loaded on every page (layout/theme.liquid)
 * so the card behaves the same wherever it renders, including cards injected
 * later by filtering, load-more, search and quick-add. Everything is delegated
 * or observed, so cards added after load are covered.
 *
 * - Collapses size options on small screens to two, with an "X more sizes" link
 * - Tags out-of-stock swatches light/dark so the strike line stays visible
 * - Shows the selected colour in the "Colour" legend
 * - Loads card images beyond the first only when the shopper starts to swipe
 */

(function() {
  if (window.__bbCardInit) return;
  window.__bbCardInit = true;

  /* Option rows (sizes and any other options under .bz_card_variant). On small
     screens a row that cannot show every option on one line shows none of them,
     only "N more sizes available" (N is the full count); tapping it reveals the
     options. Showing a space-dependent subset beside a count was confusing, and
     it differed from card to card. A row that fits is left alone, and one the
     shopper has expanded stays expanded. Recalculated only when the row's width
     or option count changes, so it never loops with the DOM observer below. */
  const MOBILE_BREAKPOINT = 768;

  function onOneLine(els) {
    return els.every(function (el) { return Math.abs(el.offsetTop - els[0].offsetTop) < 2; });
  }

  function showAll(row, chips) {
    chips.forEach(function (chip) { chip.style.display = ''; });
    var old = row.querySelector('[data-more-options]');
    if (old) old.remove();
  }

  function fitOptionRow(row) {
    if (row.dataset.bbExpanded) return;
    var chips = Array.prototype.slice.call(
      row.querySelectorAll(':scope > label:not(.color-swatchimg):not(.form__label)')
    );
    var key = Math.round(row.clientWidth) + ':' + chips.length + ':' + (window.innerWidth < MOBILE_BREAKPOINT);
    if (row.dataset.bbFit === key) return;

    showAll(row, chips);
    if (window.innerWidth >= MOBILE_BREAKPOINT || chips.length < 2 || onOneLine(chips)) {
      row.dataset.bbFit = key;
      return;
    }

    var legend = row.closest('fieldset, .product-form__input');
    legend = legend && legend.querySelector('legend');
    var noun = legend && /size/i.test(legend.textContent) ? 'size' : 'option';
    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'bb-card__more';
    more.setAttribute('data-more-options', 'true');
    row.appendChild(more);

    chips.forEach(function (chip) { chip.style.display = 'none'; });
    more.textContent = chips.length + ' more ' + noun + (chips.length === 1 ? '' : 's') + ' available';

    more.addEventListener('click', function (e) {
      e.preventDefault();
      row.dataset.bbExpanded = 'true';
      showAll(row, chips);
    });
    row.dataset.bbFit = key;
  }

  function fitOptionRows() {
    document.querySelectorAll('.bb-card .bz_card_variant .d-flex.flex-wrap').forEach(fitOptionRow);
  }


  /* Out-of-stock swatch line: white on dark colours, dark on light ones.
     CSS cannot read a colour's brightness, so tag each swatch with it. */
  function toneSwatches(root) {
    (root || document).querySelectorAll(
      '.bb-card input.disabled + label .swatch, .bb-card input:disabled + label .swatch, .bb-card .swatch.swatch--unavailable, .bb-card color-swatch input.disabled + label > span, .bb-card color-swatch input:disabled + label > span'
    ).forEach(function (el) {
      if (el.hasAttribute('data-tone')) return;
      var m = getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
      if (!m || m.length < 3 || (m.length > 3 && +m[3] === 0)) return;
      var lum = 0.299 * m[0] + 0.587 * m[1] + 0.114 * m[2];
      el.setAttribute('data-tone', lum > 150 ? 'light' : 'dark');
    });
  }
  /* Selected colour in the "Color" legend, kept in step with the swatches.
     Written only when it changes so the observer below cannot loop. */
  function updateColourLabels() {
    document.querySelectorAll('.bb-card legend.color-variant').forEach(function (leg) {
      var scope = leg.closest('fieldset');
      var checked = scope && scope.querySelector('input[type="radio"]:checked');
      var name = checked ? (checked.value || '').trim() : '';
      var span = leg.querySelector('.bb-card__selected-colour');
      if (!name) { if (span) span.remove(); return; }
      if (!span) {
        span = document.createElement('span');
        span.className = 'bb-card__selected-colour';
        leg.appendChild(span);
      }
      var text = ': ' + name;
      if (span.textContent !== text) span.textContent = text;
    });
  }

  function refreshSwatchUi() {
    toneSwatches();
    updateColourLabels();
    fitOptionRows();
  }

  refreshSwatchUi();
  document.addEventListener('DOMContentLoaded', refreshSwatchUi);
  document.addEventListener('shopify:section:load', refreshSwatchUi);
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('.bb-card input[type="radio"]')) {
      setTimeout(updateColourLabels, 0);
    }
  });
  if ('MutationObserver' in window) {
    var toneTimer;
    new MutationObserver(function () {
      clearTimeout(toneTimer);
      toneTimer = setTimeout(refreshSwatchUi, 100);
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  /* Card image swipe — slides after the first ship without src/srcset
     (data-fc-src / data-fc-srcset). Nothing beyond the first image is
     requested until the shopper starts a swipe/drag or changes colour,
     then only the active slide and the next one are loaded. */
  function loadSlide(slide) {
    var img = slide && slide.querySelector('img[data-fc-deferred]');
    if (!img) return;
    img.loading = 'eager';
    if (img.dataset.fcSrcset) img.srcset = img.dataset.fcSrcset;
    if (img.dataset.fcSrc) img.src = img.dataset.fcSrc;
    img.removeAttribute('data-fc-deferred');
  }

  function loadAround(el) {
    var slides = el.querySelectorAll('.swiper-slide');
    var i = el.swiper ? el.swiper.activeIndex : 0;
    loadSlide(slides[i]);
    loadSlide(slides[i + 1]);
  }

  function bindSlider(el) {
    if (el._fcLazyBound || !el.swiper) return;
    el._fcLazyBound = true;
    el.swiper.on('slideChangeTransitionStart', function () {
      loadAround(el);
    });
  }

  document.addEventListener('pointerdown', function (e) {
    var el = e.target.closest && e.target.closest('.card-media-slider');
    if (!el) return;
    bindSlider(el);
    loadAround(el);
  }, { passive: true });

  // Colour swatch changes slide the card to that variant's image.
  document.addEventListener('change', function (e) {
    var card = e.target.closest && e.target.closest('.card-wrapper');
    var el = card && card.querySelector('.card-media-slider');
    if (!el) return;
    [50, 500].forEach(function (ms) {
      setTimeout(function () {
        bindSlider(el);
        loadAround(el);
      }, ms);
    });
  });

  // Window size and font loading both change what fits in a row.
  var fitTimer;
  window.addEventListener('resize', function () {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(fitOptionRows, 150);
  });
  window.addEventListener('load', fitOptionRows);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitOptionRows);
})();
